<div class="main-content">
	<div class="container-fluid">
		<div class="card">
			<div class="card-header card-header-{{color}}-6">
				<h4 class="card-title pointer">
					<i class="material-icons" (click)="back()">arrow_left</i>
					<span class="bold">Inventory Promos</span>
				</h4>
			</div>
			<div class="card-body p-0">
				<mat-tab-group mat-align-tabs="start" color="accent">

					<!-- ═══ TAB: PROMOS ═══ -->
					<mat-tab label="Promos">

						<!-- LIST VIEW -->
						<ng-container *ngIf="!editingpromo && !newpromo">
							<div class="promo-toolbar">
								<div class="promo-toolbar__search promo-toolbar-search-native">
									<mat-icon class="promo-toolbar-search-native__icon">search</mat-icon>
									<input type="search" class="promo-toolbar-search-native__input" placeholder="Name, item, date…" (input)="searchPromos($event.target.value)" [formControl]="searchpromo" autocomplete="off" />
									<button type="button" class="promo-toolbar-search-native__clear" *ngIf="searchpromo.value" (click)="searchpromo.setValue(''); searchPromos('')" aria-label="Clear search">
										<mat-icon>clear</mat-icon>
									</button>
								</div>
								<div class="promo-toolbar__actions">
									<mat-slide-toggle [formControl]="hideExpiredPromos" (change)="toggleExpiredPromos()">Hide Expired</mat-slide-toggle>
									<span class="promo-count" *ngIf="sortedPromos">{{ sortedPromos.length }} promo{{ sortedPromos.length !== 1 ? 's' : '' }}</span>
									<button mat-icon-button matTooltip="Refresh from server" (click)="refreshData()" [disabled]="loadingPromos">
										<mat-icon [class.spin]="loadingPromos">refresh</mat-icon>
									</button>
									<button mat-raised-button color="accent" (click)="newPromo()">
										<mat-icon>add</mat-icon> New Promo
									</button>
								</div>
							</div>

							<div class="promo-table-wrap">
								<table class="promo-table">
									<thead>
										<tr>
											<th class="sortable" (click)="sortTable('stockid')">Item# <mat-icon class="sort-icon">{{ getSortIcon('stockid') }}</mat-icon></th>
											<th class="sortable" (click)="sortTable('name')">Name <mat-icon class="sort-icon">{{ getSortIcon('name') }}</mat-icon></th>
											<th class="sortable" (click)="sortTable('typedesc')">Type <mat-icon class="sort-icon">{{ getSortIcon('typedesc') }}</mat-icon></th>
											<th class="text-right sortable" (click)="sortTable('price')">Price <mat-icon class="sort-icon">{{ getSortIcon('price') }}</mat-icon></th>
											<th class="text-right sortable" (click)="sortTable('discount')">Discount <mat-icon class="sort-icon">{{ getSortIcon('discount') }}</mat-icon></th>
											<th class="text-right sortable" (click)="sortTable('stock')">QOH <mat-icon class="sort-icon">{{ getSortIcon('stock') }}</mat-icon></th>
											<th class="text-center sortable" (click)="sortTable('start_date')">Start <mat-icon class="sort-icon">{{ getSortIcon('start_date') }}</mat-icon></th>
											<th class="text-center sortable" (click)="sortTable('end_date')">End <mat-icon class="sort-icon">{{ getSortIcon('end_date') }}</mat-icon></th>
											<th class="actions-col"></th>
										</tr>
									</thead>
									<tbody>
										<tr *ngFor="let p of sortedPromos" class="promo-row">
											<td class="stockid-cell">{{ p.stockid }}</td>
											<td [innerHTML]="noNewLines(p.name)"></td>
											<td><span class="type-badge">{{ p.typedesc }}</span></td>
											<td class="text-right">{{ p.price | currency }}</td>
											<td class="text-right">{{ p.discount | percent }}</td>
											<td class="text-right">{{ p.stock }}</td>
											<td class="text-center date-cell">{{ p.start_date }}</td>
											<td class="text-center date-cell">{{ p.end_date }}</td>
											<td class="row-actions">
												<button mat-icon-button class="action-btn action-btn--edit" matTooltip="Edit" (click)="loadPromo(p)">
													<mat-icon>edit</mat-icon>
												</button>
												<button mat-icon-button class="action-btn action-btn--delete" matTooltip="Delete" (click)="removePromo(p)">
													<mat-icon>delete_outline</mat-icon>
												</button>
											</td>
										</tr>
										<tr *ngIf="loadingPromos">
											<td colspan="9" class="empty-state">
												<mat-spinner diameter="28"></mat-spinner>
												<span>Loading promos…</span>
											</td>
										</tr>
										<tr *ngIf="!loadingPromos && sortedPromos && sortedPromos.length === 0">
											<td colspan="9" class="empty-state">
												<mat-icon>local_offer</mat-icon>
												<span>No promos found</span>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</ng-container>

						<!-- ═══ EDIT / NEW PROMO ═══ -->
						<ng-container *ngIf="editingpromo || newpromo">

							<!-- Top bar -->
							<div class="editor-bar">
								<button mat-stroked-button (click)="editingpromo = false; newpromo = false;">
									<mat-icon>arrow_back</mat-icon> Back
								</button>
								<div class="editor-bar__title">
									<span *ngIf="newpromo">New Promo</span>
									<span *ngIf="editingpromo">{{ editingpromo.stockid }} — {{ editingpromo.name }}</span>
								</div>
								<div class="editor-bar__save">
									<mat-spinner diameter="24" *ngIf="saving"></mat-spinner>
									<button mat-raised-button color="accent" (click)="addPromo()" *ngIf="!saving">
										<mat-icon>save</mat-icon> {{ newpromo ? 'Create' : 'Save' }}
									</button>
								</div>
							</div>

							<form [formGroup]="itemForm" autocomplete="off" novalidate class="editor-body">
								<div class="row m-0">

									<!-- LEFT: Setup -->
									<div class="col-lg-7 p-2">
										<div class="section-card">
											<div class="section-card__header section-card__header--primary">
												<mat-icon>settings</mat-icon>
												<span>Setup</span>
											</div>
											<div class="section-card__body">
												<div class="promo-form-grid">
													<div class="promo-field">
														<label class="promo-field__label" for="promo-brand">Brand</label>
														<select id="promo-brand" class="promo-select" formControlName="brand" required>
															<option *ngFor="let k of brands" [ngValue]="k.manufacturer_id">{{ k.name }}</option>
														</select>
													</div>
													<div class="promo-field">
														<label class="promo-field__label" for="promo-category">Category</label>
														<select id="promo-category" class="promo-select" formControlName="categoryid" required>
															<option *ngFor="let k of properties?.categories" [ngValue]="k.value">{{ k.name }}</option>
														</select>
													</div>
													<div class="promo-field">
														<label class="promo-field__label" for="promo-line">Product line</label>
														<select id="promo-line" class="promo-select" formControlName="lineid" required>
															<option *ngFor="let k of properties?.productlines" [ngValue]="k.value">{{ k.name }}</option>
														</select>
													</div>
													<div class="promo-field">
														<label class="promo-field__label" for="promo-mfg">Mfg part #</label>
														<input id="promo-mfg" class="promo-input" type="text" formControlName="mfgpart" autocomplete="off" (keydown.enter)="$event.preventDefault()">
													</div>
													<div class="promo-field">
														<label class="promo-field__label" for="promo-stockid">Item #</label>
														<input id="promo-stockid" class="promo-input" type="text" formControlName="stockid" required maxlength="20" autocomplete="off" (keydown.enter)="$event.preventDefault()">
													</div>
													<div class="promo-field promo-field--full">
														<mat-slide-toggle [formControl]="includeInactiveVendor">Include inactive vendors</mat-slide-toggle>
													</div>
													<div class="promo-field vendor-field-wrap" #vendorFieldWrap>
														<label class="promo-field__label" for="promo-vendor">Vendor</label>
														<div class="promo-input-wrap">
															<span class="promo-input__prefix promo-input__prefix--icon" aria-hidden="true"><i class="material-icons">search</i></span>
															<input id="promo-vendor" class="promo-input" type="text" [value]="vendorSearchText" (input)="onVendorInput($event)" (focus)="onVendorFocus()" (blur)="onVendorBlur()" placeholder="Search vendor…" autocomplete="off" (keydown.enter)="$event.preventDefault()">
														</div>
														<ul class="vendor-panel" *ngIf="vendorPanelOpen && vendorresults?.length" role="listbox">
															<li *ngFor="let v of vendorresults" role="option" (mousedown)="$event.preventDefault()" (click)="selectVendor(v)">{{ v.supplierid }} — {{ v.suppname }}</li>
														</ul>
													</div>
													<div class="promo-field promo-field--full">
														<label class="promo-field__label" for="promo-name">Name</label>
														<input id="promo-name" class="promo-input" type="text" formControlName="name" required autocomplete="off" (keydown.enter)="$event.preventDefault()">
													</div>
													<div class="promo-field promo-field--full">
														<label class="promo-field__label" for="promo-desc">Description</label>
														<input id="promo-desc" class="promo-input" type="text" formControlName="description" autocomplete="off" (keydown.enter)="$event.preventDefault()">
													</div>
												</div>
											</div>
										</div>
									</div>

									<!-- RIGHT: Pricing & Dates -->
									<div class="col-lg-5 p-2">
										<div class="section-card">
											<div class="section-card__header section-card__header--success">
												<mat-icon>attach_money</mat-icon>
												<span>Pricing &amp; Dates</span>
											</div>
											<div class="section-card__body">
												<div class="promo-form-grid">
													<div class="promo-field promo-field--full">
														<label class="promo-field__label" for="promo-type">Promo type</label>
														<select id="promo-type" class="promo-select" formControlName="promotype" required>
															<option *ngFor="let k of promo_types" [ngValue]="k.value">{{ k.label }}</option>
														</select>
													</div>
													<div class="promo-field">
														<label class="promo-field__label" for="promo-price">Price</label>
														<div class="promo-input-wrap">
															<span class="promo-input__prefix">$</span>
															<input id="promo-price" class="promo-input" type="number" step="0.01" formControlName="price" (keydown.enter)="$event.preventDefault()">
														</div>
													</div>
													<div class="promo-field">
														<label class="promo-field__label" for="promo-discount">Discount</label>
														<div class="promo-input-wrap">
															<input id="promo-discount" class="promo-input" type="number" step="0.01" formControlName="discount" (keydown.enter)="$event.preventDefault()">
															<span class="promo-input__suffix">%</span>
														</div>
													</div>
													<div class="promo-field">
														<label class="promo-field__label" for="promo-cost">Cost</label>
														<div class="promo-input-wrap">
															<span class="promo-input__prefix">$</span>
															<input id="promo-cost" class="promo-input" type="number" step="0.01" formControlName="cost" required (keydown.enter)="$event.preventDefault()">
														</div>
													</div>
												</div>
												<div class="promo-datepicker-row">
													<div class="promo-field promo-field--datepicker">
														<span class="promo-field__label">Start</span>
														<mat-form-field appearance="legacy" class="promo-datepicker-mat">
															<input matInput [matDatepicker]="promoStart" formControlName="startdate" id="promo-start">
															<mat-datepicker-toggle matSuffix [for]="promoStart" aria-label="Open calendar"></mat-datepicker-toggle>
															<mat-datepicker #promoStart></mat-datepicker>
														</mat-form-field>
													</div>
													<div class="promo-field promo-field--datepicker">
														<span class="promo-field__label">End</span>
														<mat-form-field appearance="legacy" class="promo-datepicker-mat">
															<input matInput [matDatepicker]="promoEnd" formControlName="enddate" id="promo-end">
															<mat-datepicker-toggle matSuffix [for]="promoEnd" aria-label="Open calendar"></mat-datepicker-toggle>
															<mat-datepicker #promoEnd></mat-datepicker>
														</mat-form-field>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>

								<!-- ═══ ITEMS IN PROMO ═══ -->
								<ng-container *ngIf="!newpromo">
									<div class="row m-0">
										<div class="col-12 p-2">
											<div class="section-card">
												<div class="section-card__header section-card__header--info">
													<mat-icon>inventory_2</mat-icon>
													<span>Items in Promotion</span>
													<span class="badge-count" *ngIf="promoitems && promoitems.length">{{ promoitems.length }}</span>
												</div>
												<div class="section-card__body p-0">
													<ng-container *ngIf="promoitems && promoitems.length">
														<table class="promo-table promo-table--compact">
															<thead>
																<tr>
																	<th>Item #</th>
																	<th>Description</th>
																	<th class="text-right">Price</th>
																	<th class="text-right">Discount</th>
																	<th class="text-center">Qty</th>
																	<th>Type</th>
																	<th class="actions-col"></th>
																</tr>
															</thead>
															<tbody>
																<tr *ngFor="let p of promoitems">
																	<td class="stockid-cell">{{ p.item }}</td>
																	<td>{{ p.description }}</td>
																	<td class="text-right" *ngIf="isPromoKitComponentLine(p)">{{ p.price | currency }}</td>
																	<td class="text-right" *ngIf="!isPromoKitComponentLine(p)">
																		<input type="number" step="0.01" class="inline-input text-right" [(ngModel)]="p._editPrice" [ngModelOptions]="{standalone: true}" [placeholder]="p.price">
																	</td>
																	<td class="text-right" *ngIf="isPromoKitComponentLine(p)">{{ p.discount | percent }}</td>
																	<td class="text-right" *ngIf="!isPromoKitComponentLine(p)">
																		<input type="number" step="0.01" class="inline-input text-right" [(ngModel)]="p._discPct" [ngModelOptions]="{standalone: true}" placeholder="0" title="Discount %">
																	</td>
																	<td class="text-center" *ngIf="isPromoKitComponentLine(p)">{{ p.qty }}</td>
																	<td class="text-center" *ngIf="!isPromoKitComponentLine(p)">
																		<input type="number" class="inline-input text-center" [(ngModel)]="p._editQty" [ngModelOptions]="{standalone: true}" min="1" placeholder="1">
																	</td>
																	<td><span class="type-badge">{{ p.typedesc }}</span></td>
																	<td class="row-actions">
																		<button mat-icon-button class="action-btn action-btn--delete" matTooltip="Remove from promo" (click)="removePromoItem(p)">
																			<mat-icon>remove_circle_outline</mat-icon>
																		</button>
																	</td>
																</tr>
															</tbody>
														</table>
													</ng-container>
													<div class="empty-inline" *ngIf="!promoitems || !promoitems.length">
														<mat-icon>add_shopping_cart</mat-icon> No items yet — use the search below to add items
													</div>
												</div>
											</div>
										</div>
									</div>

									<!-- ═══ ADD ITEMS ═══ -->
									<div class="row m-0">
										<div class="col-12 p-2">
											<div class="section-card">
												<div class="section-card__header section-card__header--warning">
													<mat-icon>playlist_add</mat-icon>
													<span>Add Items to Promo</span>
												</div>
												<div class="section-card__body">
													<div class="add-items-filters">
														<div class="filter-checkgroup" *ngIf="properties?.categories?.length">
															<div class="filter-checkgroup__header">
																<span class="filter-checkgroup__title" id="add-filter-cat-label">Category</span>
																<span class="filter-checkgroup__count" *ngIf="categoryControl.value?.length">{{ categoryControl.value.length }} selected</span>
																<div class="filter-checkgroup__actions" role="group" aria-label="Category bulk selection">
																	<button type="button" class="filter-checkgroup__action" (click)="selectAllCategories()">All</button>
																	<button type="button" class="filter-checkgroup__action" (click)="selectNoneCategories()">None</button>
																</div>
															</div>
															<div class="filter-checkgroup__list" role="group" aria-labelledby="add-filter-cat-label">
																<label *ngFor="let c of properties.categories" class="filter-check">
																	<input type="checkbox" [checked]="isCategorySelected(c.value)" (change)="onCategoryCheckboxChange(c.value, $event)">
																	<span class="filter-check__text">{{ c.name }}</span>
																</label>
															</div>
														</div>
														<div class="filter-checkgroup" *ngIf="properties?.productlines?.length">
															<div class="filter-checkgroup__header">
																<span class="filter-checkgroup__title" id="add-filter-pl-label">Product line</span>
																<span class="filter-checkgroup__count" *ngIf="productLineControl.value?.length">{{ productLineControl.value.length }} selected</span>
																<div class="filter-checkgroup__actions" role="group" aria-label="Product line bulk selection">
																	<button type="button" class="filter-checkgroup__action" (click)="selectAllProductLines()">All</button>
																	<button type="button" class="filter-checkgroup__action" (click)="selectNoneProductLines()">None</button>
																</div>
															</div>
															<div class="filter-checkgroup__list" role="group" aria-labelledby="add-filter-pl-label">
																<label *ngFor="let p of properties.productlines" class="filter-check">
																	<input type="checkbox" [checked]="isProductLineSelected(p.value)" (change)="onProductLineCheckboxChange(p.value, $event)">
																	<span class="filter-check__text">{{ p.name }}</span>
																</label>
															</div>
														</div>
														<div class="add-items-filters__toggle">
															<mat-slide-toggle [formControl]="include_disabled">Include discontinued</mat-slide-toggle>
														</div>
														<div class="add-items-filters__search-row">
															<div class="add-items-filters__search-field">
																<label class="promo-field__label" for="add-item-search">Search by part # / description</label>
																<div class="add-items-search-wrap">
																	<mat-spinner diameter="18" *ngIf="searching"></mat-spinner>
																	<mat-icon *ngIf="!searching" class="add-items-search-wrap__icon">search</mat-icon>
																	<input id="add-item-search" type="search" [formControl]="itemSearchControl" (keyup.enter)="searchItems()" placeholder="Type and press Enter or Search…" autocomplete="off">
																	<button type="button" class="promo-toolbar-search-native__clear" *ngIf="allitems.length && !searching" (click)="clearForm()" aria-label="Clear">
																		<mat-icon>clear</mat-icon>
																	</button>
																</div>
															</div>
															<button mat-raised-button color="accent" class="add-items-filters__go" type="button" (click)="searchItems()">
																<mat-icon>search</mat-icon> Search
															</button>
														</div>
													</div>

													<div class="promo-table-wrap" *ngIf="allitems && allitems.length">
														<table class="promo-table promo-table--compact">
															<thead>
																<tr>
																	<th>Item #</th>
																	<th>Description</th>
																	<th>Type</th>
																	<th class="text-right">Price</th>
																	<th class="text-right">Discount</th>
																	<th class="text-center">Qty</th>
																	<th class="actions-col"></th>
																</tr>
															</thead>
															<tbody>
																<tr *ngFor="let item of allitems" [class.row-discontinued]="item.discontinued">
																	<td class="stockid-cell">
																		{{ item.stockid }}
																		<small class="vendor-tag" *ngIf="item.supplierno">{{ item.supplierno }}</small>
																	</td>
																	<td>{{ item.description }}</td>
																	<td><span class="type-badge">{{ item.typedesc }}</span></td>
																	<td class="text-right">
																		<input type="number" step="0.01" class="inline-input text-right" [value]="item.inputprice || item.price" (input)="item.inputprice = $event.target.value" [placeholder]="item.price">
																	</td>
																	<td class="text-right">
																		<input type="number" step="0.01" class="inline-input text-right" [value]="item.discount" (input)="item.discount = $event.target.value" placeholder="0">
																	</td>
																	<td class="text-center">
																		<input type="number" class="inline-input text-center" [value]="item.quantity ?? 1" (input)="item.quantity = $event.target.value" placeholder="1" min="1">
																	</td>
																	<td class="row-actions">
																		<button mat-mini-fab color="accent" matTooltip="Add to promo" (click)="addPrommoItem(item)">
																			<mat-icon>add</mat-icon>
																		</button>
																	</td>
																</tr>
															</tbody>
														</table>
													</div>
													<div class="empty-inline" *ngIf="!searching && itemSearchControl.value && allitems.length === 0">
														<mat-icon>search_off</mat-icon> No items found for "{{ itemSearchControl.value }}"
													</div>
												</div>
											</div>
										</div>
									</div>
								</ng-container>
							</form>
						</ng-container>
					</mat-tab>

					<!-- ═══ TAB: MIX & MATCH ═══ -->
					<mat-tab label="Mix &amp; Match">

						<!-- LIST VIEW -->
						<ng-container *ngIf="!editingmm && !newmm">
							<div class="promo-toolbar">
								<div class="promo-toolbar__search promo-toolbar-search-native">
									<mat-icon class="promo-toolbar-search-native__icon">search</mat-icon>
									<input type="search" class="promo-toolbar-search-native__input" placeholder="Name, item, date…" (input)="searchMix($event.target.value)" [formControl]="searchmix" autocomplete="off" />
									<button type="button" class="promo-toolbar-search-native__clear" *ngIf="searchmix.value" (click)="searchmix.setValue(''); searchMix('')" aria-label="Clear search">
										<mat-icon>clear</mat-icon>
									</button>
								</div>
								<div class="promo-toolbar__actions">
									<mat-slide-toggle [formControl]="hideExpiredMMs" (change)="toggleExpiredMMs()">Hide Expired</mat-slide-toggle>
									<span class="promo-count" *ngIf="sortedMMs">{{ sortedMMs.length }} rule{{ sortedMMs.length !== 1 ? 's' : '' }}</span>
									<button mat-icon-button matTooltip="Refresh from server" (click)="refreshData()" [disabled]="loadingMMs">
										<mat-icon [class.spin]="loadingMMs">refresh</mat-icon>
									</button>
									<button mat-raised-button color="accent" (click)="toggleNewMM()">
										<mat-icon>add</mat-icon> New Mix &amp; Match
									</button>
								</div>
							</div>

							<div class="promo-table-wrap">
								<table class="promo-table">
									<thead>
										<tr>
											<th class="sortable" (click)="sortMMTable('stockid')">Item# <mat-icon class="sort-icon">{{ getMMSortIcon('stockid') }}</mat-icon></th>
											<th class="sortable" (click)="sortMMTable('name')">Name <mat-icon class="sort-icon">{{ getMMSortIcon('name') }}</mat-icon></th>
											<th class="text-center sortable" (click)="sortMMTable('start_date')">Start <mat-icon class="sort-icon">{{ getMMSortIcon('start_date') }}</mat-icon></th>
											<th class="text-center sortable" (click)="sortMMTable('stop_date')">End <mat-icon class="sort-icon">{{ getMMSortIcon('stop_date') }}</mat-icon></th>
											<th class="text-center">Min Qty</th>
											<th class="text-center sortable" (click)="sortMMTable('products')">Products <mat-icon class="sort-icon">{{ getMMSortIcon('products') }}</mat-icon></th>
											<th class="actions-col"></th>
										</tr>
									</thead>
									<tbody>
										<tr *ngFor="let p of sortedMMs" class="promo-row">
											<td class="stockid-cell">{{ p.stockid }}</td>
											<td [innerHTML]="noNewLines(p.name)"></td>
											<td class="text-center date-cell">{{ p.start_date }}</td>
											<td class="text-center date-cell">{{ p.stop_date }}</td>
											<td class="text-center">{{ p.floor }}</td>
											<td class="text-center"><span class="count-badge">{{ p.products }}</span></td>
											<td class="row-actions">
												<button mat-icon-button class="action-btn action-btn--edit" matTooltip="Edit" (click)="loadMM(p)">
													<mat-icon>edit</mat-icon>
												</button>
												<button mat-icon-button class="action-btn action-btn--delete" matTooltip="Delete" (click)="removeMM(p)">
													<mat-icon>delete_outline</mat-icon>
												</button>
											</td>
										</tr>
										<tr *ngIf="loadingMMs">
											<td colspan="7" class="empty-state">
												<mat-spinner diameter="28"></mat-spinner>
												<span>Loading…</span>
											</td>
										</tr>
										<tr *ngIf="!loadingMMs && sortedMMs && sortedMMs.length === 0">
											<td colspan="7" class="empty-state">
												<mat-icon>shuffle</mat-icon>
												<span>No mix &amp; match rules found</span>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</ng-container>

						<!-- EDIT / NEW MM -->
						<ng-container *ngIf="editingmm || newmm">
							<div class="editor-bar">
								<button mat-stroked-button (click)="closeMM()">
									<mat-icon>arrow_back</mat-icon> Back
								</button>
								<div class="editor-bar__title">
									<span *ngIf="newmm">New Mix &amp; Match</span>
									<span *ngIf="editingmm">Edit — {{ editingmm.stockid }}</span>
								</div>
								<div class="editor-bar__save" *ngIf="newmm">
									<mat-spinner diameter="24" *ngIf="saving"></mat-spinner>
									<button mat-raised-button color="accent" (click)="createMM()" *ngIf="!saving">
										<mat-icon>save</mat-icon> Create &amp; Add Items
									</button>
								</div>
							</div>

							<form [formGroup]="itemMMForm" autocomplete="off" novalidate (ngSubmit)="$event.preventDefault()" class="editor-body">
								<div class="row m-0">
									<div class="col-lg-7 p-2">
										<div class="section-card">
											<div class="section-card__header section-card__header--primary">
												<mat-icon>shuffle</mat-icon>
												<span>Details</span>
											</div>
											<div class="section-card__body">
												<div class="promo-form-grid">
													<div class="promo-field">
														<label class="promo-field__label" for="mm-stockid">Item #</label>
														<input id="mm-stockid" class="promo-input" type="text" formControlName="stockid" required autocomplete="off" (keydown.enter)="$event.preventDefault()" appNoEnterKey>
													</div>
													<div class="promo-field promo-field--full">
														<label class="promo-field__label" for="mm-name">Name</label>
														<input id="mm-name" class="promo-input" type="text" formControlName="name" required autocomplete="off" (keydown.enter)="$event.preventDefault()" appNoEnterKey>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="col-lg-5 p-2">
										<div class="section-card">
											<div class="section-card__header section-card__header--success">
												<mat-icon>tune</mat-icon>
												<span>Rules</span>
											</div>
											<div class="section-card__body">
												<div class="promo-form-grid">
													<div class="promo-field">
														<label class="promo-field__label" for="mm-floor">Min qty</label>
														<input id="mm-floor" class="promo-input" type="number" formControlName="floor" required (keydown.enter)="$event.preventDefault()" appNoEnterKey appNumericField>
													</div>
													<div class="promo-field">
														<label class="promo-field__label" for="mm-subtotal">Subtotal</label>
														<div class="promo-input-wrap">
															<span class="promo-input__prefix">$</span>
															<input id="mm-subtotal" class="promo-input" type="number" step="0.01" formControlName="subtotal" required (keydown.enter)="$event.preventDefault()" appNoEnterKey appNumericField>
														</div>
													</div>
												</div>
												<div class="promo-datepicker-row">
													<div class="promo-field promo-field--datepicker">
														<span class="promo-field__label">Start</span>
														<mat-form-field appearance="legacy" class="promo-datepicker-mat">
															<input matInput [matDatepicker]="mmStart" formControlName="startdate" id="mm-start" appNoEnterKey>
															<mat-datepicker-toggle matSuffix [for]="mmStart" aria-label="Open calendar"></mat-datepicker-toggle>
															<mat-datepicker #mmStart></mat-datepicker>
														</mat-form-field>
													</div>
													<div class="promo-field promo-field--datepicker">
														<span class="promo-field__label">End</span>
														<mat-form-field appearance="legacy" class="promo-datepicker-mat">
															<input matInput [matDatepicker]="mmEnd" formControlName="enddate" id="mm-end" appNoEnterKey>
															<mat-datepicker-toggle matSuffix [for]="mmEnd" aria-label="Open calendar"></mat-datepicker-toggle>
															<mat-datepicker #mmEnd></mat-datepicker>
														</mat-form-field>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</form>

							<ng-container *ngIf="exists || editingmm">
								<div class="row m-0">
									<div class="col-12 p-2">
										<div class="section-card">
											<div class="section-card__header section-card__header--info">
												<mat-icon>rule</mat-icon>
												<span>Mix &amp; Match Items</span>
											</div>
											<div class="section-card__body">
												<mat-spinner *ngIf="saving" diameter="28"></mat-spinner>
												<app-inventory-searcher (saveresults)="saveMm($event)" [rule]="mm" [forceupdate]="triggersearch"></app-inventory-searcher>
											</div>
										</div>
									</div>
								</div>
							</ng-container>
						</ng-container>
					</mat-tab>

				</mat-tab-group>
			</div>
		</div>
	</div>
</div>
